import React from 'react'
import { Section } from '../Styled';
import { CaseElement, CaseGrid } from './CaseSlider.styled';
import TICTACTOE from '../images/Cases/TicTacToe-Complete.png';
import JEWELLY from '../images/Cases/Jewelly-Complete.png';
import MOVIEDB from '../images/Cases/MovieDatabase-Complete.png';

const CASES = [
    {
        id: '0',
        title: 'Kryds og bolle spil',
        lnk: TICTACTOE,
        class: 'prpl',
        nav: 'https://tictactoe-by-noaly.surge.sh/'
    },
    {
        id: '1',
        title: 'Jewelly webshop',
        lnk: JEWELLY,
        class: 'blu',
        nav: 'https://jewelly.dk/',
    },
    {
        id: '2',
        title: 'Vores film database',
        lnk: MOVIEDB,
        class: 'darkblu',
        nav: 'https://movie-database-by-noaly.surge.sh/',
    },
]

const CaseSlider = () => {
    return (
        <Section>
            <CaseGrid>
                {
                    CASES.map(item => (
                        <CaseElement
                            key={item.id}
                            className={item.class}
                            href={item.nav}
                            target='_blank' rel='noreferrer'
                            title={`Gå til ${item.title}`}
                        >
                            <img src={item.lnk} alt={item.title} />
                            <h1>
                                {item.title}
                            </h1>
                        </CaseElement>
                    ))
                }
            </CaseGrid>
        </Section>
    )
};

export default CaseSlider